import { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { cleanupGSAP, initScrollAnimations } from './lib/gsap';
import Splash from './components/Splash';
import Hero from './components/Hero';
import TopTabs from './components/TopTabs';
import PrivacyPolicy from './pages/PrivacyPolicy';
import TermsOfUse from './pages/TermsOfUse';

// Import content data
import contentData from './content.json';

function App() {
  const [isLoading, setIsLoading] = useState(true);
  const [content, setContent] = useState(contentData);

  // Load content from JSON file
  useEffect(() => {
    const loadContent = async () => {
      try {
        const response = await fetch('/src/content.json');
        const data = await response.json();
        setContent(data);
      } catch (error) {
        console.error('Error loading content:', error);
        // Use default content if loading fails
        setContent(contentData);
      }
    };

    loadContent();
  }, []);

  // Initialize GSAP animations
  useEffect(() => {
    if (!isLoading) {
      initScrollAnimations();
    }

    return () => {
      cleanupGSAP();
    };
  }, [isLoading]);

  // Handle splash screen completion
  const handleSplashComplete = () => {
    setIsLoading(false);
  };

  // Removed floating contact button per request

  return (
    <Router>
      <div className="App" dir="rtl">
        <Routes>
          {/* Privacy Policy Page */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          
          {/* Terms of Use Page */}
          <Route path="/terms-of-use" element={<TermsOfUse />} />
          
          {/* Main App */}
          <Route path="/*" element={
            <>
              {/* Splash Screen */}
              {isLoading && <Splash onComplete={handleSplashComplete} />}

              {/* Main Content */}
              {!isLoading && (
                <>
                  {/* Top Tabs */}
                  <TopTabs sections={[
                    { key: '10factory', title: '10factory' },
                    { key: '10gift', title: '10gifts' },
                    { key: '10event', title: '10events' },
                    { key: '10ai', title: '10AI' }
                  ]} />

                  {/* Hero Section — coming-soon mode: sections, footer and contact are hidden */}
                  <Hero content={content} />
                </>
              )}
            </>
          } />
        </Routes>

        {/* Loading Indicator for reduced motion */}
        <style>
          {`
            @media (prefers-reduced-motion: reduce) {
              .magnetic:hover {
                transform: none !important;
              }
              .tilt-3d:hover {
                transform: none !important;
              }
              .animate-float {
                animation: none !important;
              }
              .animate-bounce {
                animation: none !important;
              }
              .animate-pulse {
                animation: none !important;
              }
            }
          `}
        </style>
      </div>
    </Router>
  );
}

export default App;
